export interface Column {
  /**
   * Path to property in row. For table or nested object use dot notation:
   *
   * ```typescript
   * const data = [
   *   {
   *     name: 'John',
   *     location: {
   *       city: 'New York'
   *     },
   *     children: [
   *       {
   *         name: 'Sara'
   *       }
   *     ]
   *   }
   * ]
   *
   * const columns: Column[] = [
   *   {
   *     id: 'name',
   *     label: 'Name'
   *   },
   *   {
   *     id: 'location.city',
   *     label: 'City'
   *   },
   *   {
   *     id: 'children.0.name',
   *     label: 'First child name'
   *   },
   * ]
   *
   * ```
   */
  id: string;

  /**
   * Label displayed in header.
   */
  label: string;

  /**
   * Description displayed in header when there is no label.
   */
  description?: string;

  /**
   * Wether column is displayed or not. Hidden columns are shown in detail row.
   *
   * NOTE: setting this have no effect, as it is used internally.
   */
  hidden?: boolean;

  /**
   * Minimum width of column in pixels. Default to 200px.
   */
  minWidth?: number;

  /**
   * Maximum width of column in pixels.
   */
  maxWidth?: number;

  /**
   * Determines order in which column will change to hidden state.
   * No value means 0.
   *
   * 0 - column will never be hidden
   * > 0 - column with highest `hideOrder` will be hidden first
   */
  hideOrder?: number;

  /** Whether column is sortable or not. */
  sortable?: boolean;

  /** Determines if column contains numbers. Numeric columns are right-aligned */
  numeric?: boolean;

  /** Determines if column should have translated header */
  disableTranslate?: boolean;

  unit?: number;

  style?: string;

  format?: string;
  /** required to display enums properly */
  vals?: any[];

  /** Whether column should be sticky at the left side of the table */
  sticky?: boolean;

  /** Whether column should be sticky at the right side of the table */
  stickyEnd?: boolean;

  /** Whether column values should be grouped by sum, average or any other custom operation */
  grouping?: 'sum' | 'avg';
}

/** Default minimum width in pixels of every column. */
export const COLUMN_MIN_WIDTH = 180;
